import { Breadcrumb } from 'modules/model-json';

export const KITCHEN_COLLECTIONS_PATH = '/proekt-kuhni/gotovye/';

export const KITCHEN_COLLECTIONS_CORNER_PATH = '/proekt-kuhni/gotovye/uglovye/';

export const CATEGORY_ID = '1832';

export const PRYAMYE_VARIANT_ID = '';

export const UGLOVYE_VARIANT_ID = '10002';

export const KITCHEN_COLLECTIONS_LANDING_NAME = 'kitchen-collections';

export const KITCHEN_COLLECTIONS_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/kitchen-collections';

export const MODIFIED_KITCHEN_COLLECTIONS_BREADCRUMBS: Breadcrumb[] = [
  {
    label: 'Каталог',
    link: '/catalogue/',
  },
  {
    label: 'Кухни',
    link: '/catalogue/kuhni/',
  },
  {
    label: 'Мебель для кухни',
    link: '/catalogue/mebel-dlya-kuhni/',
  },
];
